/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteFragment } from 'relay-runtime';
type ArticleSelector_viewer$ref = any;
type TopicSelector_viewer$ref = any;
export type ArticleStateType = "available" | "deleted" | "draft" | "%future added value";
export type ConfigurableBlockType = "embed" | "listNews" | "live" | "news" | "video" | "%future added value";
import type { FragmentReference } from "relay-runtime";
declare export opaque type Article_viewer$ref: FragmentReference;
export type Article_viewer = {|
  +id: string,
  +article: ?{|
    +id: string,
    +title: ?string,
    +previewPicture: ?string,
    +foreignAgent: ?boolean,
    +previewAttribution: ?string,
    +body: ?string,
    +bodyHtml: ?string,
    +lead: ?string,
    +section: ?string,
    +category: ?string,
    +topics: ?$ReadOnlyArray<?{|
      +id: string,
      +name: ?string,
    |}>,
    +linkedArticles: ?$ReadOnlyArray<?{|
      +id: string,
      +title: ?string,
    |}>,
    +author: ?string,
    +hidden: ?boolean,
    +yaGenre: ?string,
    +isEvent: ?boolean,
    +infostring: ?boolean,
    +infostring_hot: ?boolean,
    +showInYandexNews: ?boolean,
    +showInYandexZen: ?boolean,
    +availableAt: ?string,
    +seoTitle: ?string,
    +seoDescription: ?string,
    +seoKeywords: ?string,
    +preview: ?{|
      +id: string,
      +filename: ?string,
      +description: ?string,
    |},
    +combinedPreviewVideo: ?{|
      +id: string,
      +filename: ?string,
      +description: ?string,
    |},
    +mediaFiles: ?$ReadOnlyArray<?{|
      +id: string
    |}>,
    +state: ArticleStateType,
    +mainPageOrder: number,
    +slug: ?string,
    +changes: ?$ReadOnlyArray<?{|
      +userId: string,
      +userName: ?string,
      +modDate: ?string,
    |}>,
  |},
  +configurableBlock: ?{|
    +id: string,
    +type: ConfigurableBlockType,
    +slug: ?string,
    +config: ?any,
    +active: ?boolean,
  |},
  +persons: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +firstName: ?string,
        +lastName: ?string,
      |}
    |}>
  |},
  +categories: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +name: ?string,
      |}
    |}>
  |},
  +me: ?{|
    +id: string,
    +name: ?string,
    +email: ?string,
    +canDelete: ?boolean,
  |},
  +$fragmentRefs: TopicSelector_viewer$ref & ArticleSelector_viewer$ref,
  +$refType: Article_viewer$ref,
|};
*/


const node/*: ConcreteFragment*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "title",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v3 = [
  v0,
  v2
],
v4 = [
  v0,
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "filename",
    "args": null,
    "storageKey": null
  },
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "description",
    "args": null,
    "storageKey": null
  }
],
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "slug",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "Article_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "LocalArgument",
      "name": "id",
      "type": "ID!",
      "defaultValue": null
    },
    {
      "kind": "LocalArgument",
      "name": "section",
      "type": "ID!",
      "defaultValue": null
    },
    {
      "kind": "LocalArgument",
      "name": "blockSlug",
      "type": "String",
      "defaultValue": null
    }
  ],
  "selections": [
    v0,
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "article",
      "storageKey": null,
      "args": [
        {
          "kind": "Variable",
          "name": "id",
          "variableName": "id",
          "type": "ID"
        }
      ],
      "concreteType": "Article",
      "plural": false,
      "selections": [
        v0,
        v1,
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "previewPicture",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "foreignAgent",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "previewAttribution",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "body",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "bodyHtml",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "lead",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "section",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "category",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "topics",
          "storageKey": null,
          "args": null,
          "concreteType": "Topic",
          "plural": true,
          "selections": v3
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "linkedArticles",
          "storageKey": null,
          "args": null,
          "concreteType": "Article",
          "plural": true,
          "selections": [
            v0,
            v1
          ]
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "author",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "hidden",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "yaGenre",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "isEvent",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "infostring",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "infostring_hot",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "showInYandexNews",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "showInYandexZen",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "availableAt",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "seoTitle",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "seoDescription",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "seoKeywords",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "preview",
          "storageKey": null,
          "args": null,
          "concreteType": "MediaFile",
          "plural": false,
          "selections": v4
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "combinedPreviewVideo",
          "storageKey": null,
          "args": null,
          "concreteType": "MediaFile",
          "plural": false,
          "selections": v4
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "mediaFiles",
          "storageKey": null,
          "args": null,
          "concreteType": "MediaFile",
          "plural": true,
          "selections": [
            v0
          ]
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "state",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "mainPageOrder",
          "args": null,
          "storageKey": null
        },
        v5,
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "changes",
          "storageKey": null,
          "args": null,
          "concreteType": "Change",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "userId",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "userName",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "modDate",
              "args": null,
              "storageKey": null
            }
          ]
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "configurableBlock",
      "storageKey": null,
      "args": [
        {
          "kind": "Variable",
          "name": "slug",
          "variableName": "blockSlug",
          "type": "String"
        }
      ],
      "concreteType": "ConfigurableBlock",
      "plural": false,
      "selections": [
        v0,
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "type",
          "args": null,
          "storageKey": null
        },
        v5,
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "config",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "active",
          "args": null,
          "storageKey": null
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "persons",
      "storageKey": "persons(first:-1,personType:\"author\")",
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": -1,
          "type": "Int"
        },
        {
          "kind": "Literal",
          "name": "personType",
          "value": "author",
          "type": "String"
        }
      ],
      "concreteType": "PersonConnection",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "edges",
          "storageKey": null,
          "args": null,
          "concreteType": "PersonEdge",
          "plural": true,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "Person",
              "plural": false,
              "selections": [
                v0,
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "firstName",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "lastName",
                  "args": null,
                  "storageKey": null
                }
              ]
            }
          ]
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "categories",
      "storageKey": null,
      "args": [
        {
          "kind": "Variable",
          "name": "section",
          "variableName": "section",
          "type": "ID!"
        }
      ],
      "concreteType": "CategoryConnection",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "edges",
          "storageKey": null,
          "args": null,
          "concreteType": "CategoryEdge",
          "plural": true,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "Category",
              "plural": false,
              "selections": v3
            }
          ]
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "TopicSelector_viewer",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "ArticleSelector_viewer",
      "args": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "me",
      "storageKey": null,
      "args": null,
      "concreteType": "User",
      "plural": false,
      "selections": [
        v0,
        v2,
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "email",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "canDelete",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
})();
// prettier-ignore
(node/*: any*/).hash = '14d897be42b0e392c7c5c8b25b83c377';
module.exports = node;



// WEBPACK FOOTER //
// src/components/articles/__generated__/Article_viewer.graphql.js